/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:24
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-09-14 17:14:45
 * @FilePath: \ioc_base\src\modules\buildingConfig\const\accountOptions.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Dic } from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import utils from "@src/common/utils";
const accountOption = function (that) {
  return {
    index: false,
    radio: true,
    selection: false,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    menuWidth: 200,
    menuAlign: "center",
    // rowKey: "id",
    reserveSelection: true, //分页缓存
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    labelSuffix: "：",
    labelWidth: "100px",
    dialogWidth: "900px",
    viewDialogWidth: "800px",
    emptyText: "暂无账户",
    column: [
      {
        label: "账户名称",
        prop: "accountNumber",
        clearable: true,
        search: true,
        overHidden: true
      },
      {
        label: "姓名",
        prop: "nickName",
        clearable: true,
        search: true
      },
      // {
      //   label: "类型",
      //   prop: "accountType",
      //   formatter: (row, value) => {
      //     switch (Number(value)) {
      //       case 1:
      //         value = "保卫";
      //         break;
      //       case 2:
      //         value = "员工";
      //         break;
      //       default:
      //         break;
      //     }
      //     return value;
      //   }
      // },
      {
        label: "性别",
        prop: "sex",
        formatter: function (row, value) {
          return Dic.findByValue("SENU092", value);
        }
      },
      {
        label: "手机号码",
        prop: "phone"
      },
      // {
      //   label: "邮箱地址",
      //   prop: "email",
      // },
      {
        label: "角色",
        prop: "role",
        formatter: (row, value) => {
          return row.accountGroupList
            ? row.accountGroupList.map((r) => r.accountGroupName).join(",")
            : "";
        }
      },
      {
        label: "创建时间",
        prop: "createTime",
        formatter: function (row, value) {
          return value
            ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
            : "";
        }
      }
    ]
  };
};
export default accountOption;
